import {metadaApi} from '@dms/api/base';

import {
  CarkPostInsuranceDraftApiArgMetadaInsuranceNew,
  CarkPostInsuranceDraftApiResponseMetadaInsuranceNew,
  CarkPostTipApiArgMetadaInsuranceNew,
  CarkPostTipApiResponseMetadaInsuranceNew,
} from './types';

export const metadaInsuranceNewApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    carkPostInsuranceDraft: build.mutation<
      CarkPostInsuranceDraftApiResponseMetadaInsuranceNew,
      CarkPostInsuranceDraftApiArgMetadaInsuranceNew
    >({
      query: (queryArg) => ({
        url: `/insurance/v2/insuranceDraft`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    carkPostTip: build.mutation<
      CarkPostTipApiResponseMetadaInsuranceNew,
      CarkPostTipApiArgMetadaInsuranceNew
    >({
      query: (queryArg) => ({url: `/insurance/v2/tip`, method: 'POST', body: queryArg.body}),
    }),
  }),
});

export const {useCarkPostTipMutation, useCarkPostInsuranceDraftMutation} = metadaInsuranceNewApi;
